import Link from "next/link";
import { CommoditySlugs } from "../../data/DataSlugs";

export const SeoTextMultiguna = () => (
  <div className="seo-wordings-wrapper">
    <div className="seo-wordings">
      <h2>Pembiayaan Multiguna dari Home Credit Indonesia</h2>
      Sebagai pelanggan setia Home Credit, kamu bisa mengajukan mengajukan
      pinjaman multiguna FlexiFast setelah melalui proses penawaran dari pihak
      kami. Dengan ini kamu dapat menggunakan dananya untuk memenuhi berbagai
      kebutuhan yang kamu mau. Mulai dari biaya bahan bangunan dan perbaikan
      rumah, pendidikan, kendaraan, hiburan, acara khusus, hingga kebutuhan yang
      berhubungan dengan kesehatan.
      <br /> <br />
      Walau masih berdiri kokoh sejak sepuluh tahun lamanya, nyatanya rumah
      sebagai tempat tinggal juga perlu dirawat dan diperbaiki. Mulai dari
      hal-hal kecil, seperti mengecat ulang dinding kamar, mengganti ubin kamar
      mandi yang retak, karpet ruang tamu yang kotor, sampai renovasi
      besar-besaran, seperti mendesain ulang kamar tidur dan ruang tamu.
      Membutuhkan biaya yang tidak sedikit, kamu bisa memanfaatkan pembiayaan
      multiguna dari Home Credit dibanding memilih pinjaman uang online yang
      tidak terpercaya.
      <br /> <br />
      Sebab, pinjaman uang online yang digadang-gadang sebagai pinjaman uang
      online terpercaya, pinjaman uang online cepat, pinjaman uang online tanpa
      jaminan dan syarat, nyatanya sering kali tidak demikian. Banyak sekali
      persyaratan yang perlu dipenuhi untuk mendapatkan pinjaman uang online
      tersebut. Apalagi, jumlah uang yang kamu butuhkan pasti tidak sedikit.
      Untuk memperbaiki peralatan elektronik yang rusak misalnya, kamu perlu
      mengeluarkan uang yang setara dengan harga peralatan elektronik baru.
      <br /> <br />
      Selain biaya bahan bangunan dan perbaikan rumah, kamu juga bisa
      memanfaatkan pembiayaan multiguna dibanding memilih pinjaman tunai
      abal-abal untuk membayar biaya pendidikan. Tidak murah, biaya pendidikan
      yang melambung makin tinggi memang sering membuat para orangtua berada
      dalam keadaan butuh uang cepat. Dalam keadaan terdesak seperti itu,
      pinjaman uang online langsung cair atau pinjaman uang online tanpa syarat
      langsung cair jelas menjadi pilihan. Padahal, pinjaman uang online cepat
      yang ditawarkan belum tentu terpercaya. Dengan pembiayaan multiguna dari
      Home Credit, kamu bisa membayar biaya sekolah, les bahasa asing, kursus
      keterampilan, hingga biaya kuliah di luar negeri.
      <br /> <br />
      Selanjutnya, kamu juga bisa memanfaatkan pembiayaan multiguna untuk
      kendaraan. Tidak perlu tergiur dengan tawaran pinjaman uang tanpa syarat
      apapun atau pinjaman tunai tanpa jaminan langsung cair yang tidak
      terpercaya.
      <br /> <br />
      Begitu pula untuk memenuhi biaya hiburan, acara khusus, seperti pernikahan
      dan pemakaman, hingga kebutuhan yang berhubungan dengan kesehatan. Mulai
      dari medical check-up, rawat jalan, rawat inap, hingga berkonsultasi
      dengan dokter spesialis, seperti THT dan mata. Rasanya, tidak perlu
      memilih pinjaman dana tunai cepat atau tergiur dengan pinjaman dana tunai
      tanpa jaminan tanpa kartu kredit yang tidak terpercaya untuk memenuhi
      kebutuhanmu. Sebab, dengan pembiayaan multiguna dari Home Credit, kamu
      bisa memenuhi berbagai kebutuhan yang kamu mau.
      <br /> <br />
      Begitu pula untuk memenuhi biaya hiburan, acara khusus, seperti pernikahan
      dan pemakaman, hingga kebutuhan yang berhubungan dengan kesehatan. Mulai
      dari medical check-up, rawat jalan, rawat inap, hingga berkonsultasi
      dengan dokter spesialis, seperti THT dan mata. Rasanya, tidak perlu
      memilih pinjaman dana tunai cepat atau tergiur dengan pinjaman dana tunai
      tanpa jaminan tanpa kartu kredit yang tidak terpercaya untuk memenuhi
      kebutuhanmu. Sebab, dengan pembiayaan multiguna dari Home Credit, kamu
      bisa memenuhi berbagai kebutuhan yang kamu mau.
      <br />
      <br />
      Dengan Home Credit, Kamu Bisa!
    </div>
    <style jsx>{`
      .seo-wordings-wrapper {
        display: flex;
        justify-content: center;
        background-color: var(--color-white-soft);
        width: 100%;
      }

      .seo-wordings {
        width: 100%;
        margin: 48px 16px;
        font-size: 12px;
        text-align: justify;
        font-weight: 300;
        max-width: 960px;
      }

      @media only screen and (max-width: 651px) {
        .seo-wordings {
          font-size: 10.5px;
          margin: 32px 16px;
        }
      }
    `}</style>
  </div>
);

export const SeoTextShopOffline = () => (
  <div className="shop-offline-wordings-wrapper">
    <div className="shop-offline-wordings">
      <h2>
        Home Credit Indonesia, Perusahaan Pembiayaan Multiguna Multinasional
        Berbasis Teknologi
      </h2>
      PT Home Credit Indonesia atau yang lebih dikenal dengan Home Credit
      merupakan perusahaan pembiayaan multiguna multinasional. Perusahaan ini
      menyediakan layanan pembiayaan berbasis teknologi. Dengan memilih Home
      Credit, kamu bisa membeli berbagai macam produk untuk memenuhi segala
      kebutuhan. Tidak perlu repot memikirkan pembayaran, kamu bisa merasakan
      nikmatnya cicilan ringan tanpa menggunakan kartu kredit. Tidak terbatas
      pada satu produk, kamu bisa mengajukan{" "}
      <Link
        href={`/${CommoditySlugs.kreditHp}`}
        as={`/${CommoditySlugs.kreditHp}`}
      >
        <a>pembiayaan HP</a>
      </Link>{" "}
      atau smartphone,{" "}
      <Link
        href={`/${CommoditySlugs.kreditGadget}`}
        as={`/${CommoditySlugs.kreditGadget}`}
      >
        <a>pembiayaan gadget</a>
      </Link>
      ,{" "}
      <Link
        href={`/${CommoditySlugs.kreditKamera}`}
        as={`/${CommoditySlugs.kreditKamera}`}
      >
        <a>pembiayaan kamera</a>
      </Link>
      ,{" "}
      <Link
        href={`/${CommoditySlugs.kreditLaptop}`}
        as={`/${CommoditySlugs.kreditLaptop}`}
      >
        <a>pembiayaan laptop</a>
      </Link>
      ,{" "}
      <Link
        href={`/${CommoditySlugs.kreditTv}`}
        as={`/${CommoditySlugs.kreditTv}`}
      >
        <a>pembiayaan televisi</a>
      </Link>,{" "}
      <Link
        href={`/${CommoditySlugs.kreditFurnitur}`}
        as={`/${CommoditySlugs.kreditFurnitur}`}
      >
        <a>pembiayaan furnitur</a>
      </Link>
      . Dengan Home Credit, mewujudkan apa yang kamu mau tidak lagi sekadar
      mimpi! <br />
      <br />
      Didirikan pada tahun 2013 di Jakarta, saat ini Home Credit telah
      menjangkau kota-kota besar di Indonesia. Mulai dari Jakarta, Bogor,
      Bandung, Semarang, Yogyakarta, Surabaya, Malang, Palembang, Pekanbaru,
      Batam, Medan, Makassar, dan masih banyak kota lainnya. Melayani pelanggan
      secara online maupun offline. Dengan pilihan yang tidak terbatas, Home
      Credit berharap bisa memberikan layanan pembiayaan berbasis teknologi
      terbaik di Indonesia.
      <h2>Keuntungan Memilih Home Credit</h2>
      Selain menjadi partner berbelanja, Home Credit juga memungkinkan kamu
      untuk mewujudkan apa yang kamu mau. Sesuai dengan keinginan Home Credit
      untuk mengubah cara berbelanja, kamu tidak perlu menunggu lama untuk
      memenuhi segala kebutuhan. Dengan Home Credit, kamu bisa mengajukan
      cicilan HP atau smartphone, cicilan gadget, seperti smartwatch, speaker,
      tablet, cicilan kamera DSLR dan jenis lainnya, cicilan laptop ASUS dan
      merek lainnya, cicilan TV LED dan jenis lainnya, cicilan furnitur, seperti lemari
      pakaian, sofa, dan spring bed. Cukup datang ke Toko Mitra, dan dapatkan approval pengajuan
      pembiayaan barang dengan tenor 3 – 36 bulan dalam waktu sekitar 3 menit
      saja.
      <br />
      <br />
      Dengan memilih Home Credit, nikmatnya cicilan ringan tanpa kartu kredit
      bisa kamu rasakan. Selain itu, kamu juga bisa memanfaatkan promo-promo
      menarik dari berbagai mitra Home Credit. Mulai dari Promo Bunga 0%, Promo
      Bunga Bisa 0%, Promo Double Zero dengan DP dan Bunga 0%, Promo Gratis 1x
      Cicilan, Promo Bebas Biaya Admin, Promo Diskon Admin, dan promo lain yang
      tidak kalah menarik. Tidak perlu khawatir tentang proteksi produk selama
      masa cicilan berlangsung, Home Credit menawarkan proteksi tambahan melalui
      fitur AMAN dan proSERIES.
      <h2>Belanja di Mitra Home Credit</h2>
      Tidak perlu berpikir dua kali, kamu bisa langsung mewujudkan apa yang kamu
      mau dengan Home Credit. Selain menyediakan layanan pembiayaan untuk
      berbagai produk, kamu juga bisa memilih untuk berbelanja di mitra yang
      kamu inginkan. Mulai dari e-commerce, seperti Blibli, Bukalapak, dan
      Tokopedia, Home Credit juga bekerja sama dengan Erafone, Electronic City,
      Gramedia, Hypermart, IKEA, Informa, Lotte Mart, OPPO, Vivo, Wellcomm Shop,
      dan mitra lain yang tidak kalah menarik. Mendukungmu untuk memenuhi segala
      kebutuhan, Home Credit siap memberikan layanan pembiayaan berbasis
      teknologi terbaik.
      <br />
      <br />
      Tunggu apa lagi? Saatnya siapkan daftar belanjamu, beli berbagai produk
      yang kamu inginkan, dan wujudkan mimpi menjadi apa yang kamu mau.
      <br />
      <br />
      Dengan Home Credit, Kamu Bisa!
    </div>
    <style jsx>{`
      .shop-offline-wordings-wrapper {
        display: flex;
        justify-content: center;
        background-color: var(--color-white-soft);
        width: 100%;
      }
      .shop-offline-wordings {
        width: 100%;
        margin: 48px 16px;
        font-size: 12px;
        text-align: justify;
        font-weight: 300;
        max-width: 960px;
      }
      @media only screen and (max-width: 651px) {
        .shop-offline-wordings {
          font-size: 10.5px;
          margin: 32px 16px;
        }
      }
    `}</style>
  </div>
);
